import * as React from 'react';
import { IPatient } from "../../models/IPatient";
import "./PatientInformation.scss";
import { formatPersonalSecurityNumberAndOrganisationNumber } from "../../helpers/PersonalSecurityNumberAndOrganisationNumberHelper";

interface IPatientInformation {
    patient?: IPatient;
}

export const PatientInformation: React.FunctionComponent<IPatientInformation> = ({ patient }) => {
    return (
        <div className="patient-information">
            {
                patient ?
                    <div>
                        <h6>Aktuell patient</h6>
                        <p><label>Namn: </label> {patient.name} <label> Personnummer: </label> {formatPersonalSecurityNumberAndOrganisationNumber(patient.personalSecurityNumber)}</p>
                    </div>
                    : null
            }
        </div>
    )
}